import { useQuery } from '@tanstack/react-query';
import type { ActiveUsersResponse, ActiveUser } from '../../types/ActiveUser';

export default function useActiveUsers() {
  return useQuery({
    queryKey: ['/agent/api/active_users'],
    queryFn: async () => {
      const response = await fetch('/agent/api/active_users.json');
      const data: ActiveUsersResponse = await response.json();
      return { activeUsers: data.records as ActiveUser[] };
    },
  });
}
